import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatDistanceToNow, parseISO } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}



export function validationErrorToObject<T>(arr: { key: string; message: string }[]): T {
  return arr.reduce((acc, { key, message }) => {
    acc[key as keyof T] = message as T[keyof T];
    return acc;
  }, {} as T);
}


export function storePATtoken (token: string) {
  localStorage.setItem("PATtoken", token)
}
export function getPATtoken () {
   return localStorage.getItem("PATtoken")
}

export function removePATtoken () {
  localStorage.removeItem("PATtoken")
}

export const getRandomHexColor = (): string => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const stringToColor = (str: string): string => {
  let hash = 0;
  
  // Generate a hash from the string
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Convert hash to HEX color
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += value.toString(16).padStart(2, "0");
  }

  return color;
};


export function getRelativeTime(dateString: string): string {
  const date = parseISO(dateString);
  return formatDistanceToNow(date, { addSuffix: true });
}
